import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

// Helper — is this user an admin?
const isAdmin = (user) =>
  user?.role?.toLowerCase() === "admin" ||
  user?.role?.toLowerCase() === "administrator";

export default function ProtectedRoute({ requiredPermission, requiredRole }) {
  const { user } = useAuth();

  if (!user) return <Navigate to="/signin" replace />;

  // Role gate (e.g. requiredRole="admin")
  if (requiredRole) {
    const roleMatch =
      user?.role?.toLowerCase() === requiredRole.toLowerCase() ||
      isAdmin(user);
    if (!roleMatch) return <Navigate to="/dashboard" replace />;
  }

  // Admins bypass every permission check
  if (isAdmin(user)) return <Outlet />;

  // Non-admins: block access unless they hold the specific permission flag
  if (requiredPermission && !user[requiredPermission]) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
